
import VClamp from 'vue-clamp'
import { getDateDistance, slugUrl } from '@/utils'
export default {
  name: 'News',
  components: {
    VClamp,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    textClasses: {
      type: String,
      default: '',
    },
    thumbClasses: {
      type: String,
      default: '',
    },
    customTitleClass: {
      type: String,
      default: '',
    },
    thumb: {
      type: String,
      default: 'thumb550',
    },
  },
  data() {
    return {
      resizeMethod: null,
      isLoaded: false,
    }
  },
  computed: {
    showLines() {
      return this.$store.getters['resize/isMobile'] ? 4 : 2
    },
    formattedDate() {
      return getDateDistance(
        this.data.date,
        this.$store.state['date-fns'].activeLocale,
      )
    },
    slug() {
      return slugUrl(this.data?.current_url, this.data?.title)
    },
    hashtags() {
      try {
        if (
          typeof this.data?.hashTags === 'string' &&
          this.data.hashTags.length
        )
          return '#' + JSON.parse(this.data.hashTags).join(', #')

        if (Array.isArray(this.data.hashTags) && this.data.hashTags.length) {
          return '#' + this.data.hashTags.join(', #')
        }
        return []
      } catch (ex) {
        this.$sentry.captureException(
          `Content posts on hashtags ${this.data?.id}`,
          ex,
        )

        return []
      }
    },
  },
}
